export default "__VITE_ASSET__9qAOYuCK__"